import ReactDOM from 'react-dom/client';
import App from './components/App/App';
import { MoralisProvider } from 'react-moralis';
import { createStandaloneToast } from '@chakra-ui/react';
import { blockchainConfig } from './blockchain-config';
import { ColorModeScript } from '@chakra-ui/react';
import { customTheme } from './theme/customTheme';
import { overrideWindowEthereum } from './utils/ethereum';

const { ToastContainer } = createStandaloneToast();

overrideWindowEthereum();

export const disabledGames = ['0xd037102c5bc71e576fe9c0b1b8398e58be1e4ef7'].map(game => game.toLowerCase())

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
	<MoralisProvider
		serverUrl={blockchainConfig.RPC_SERVER_DOMAIN}
		appId={blockchainConfig.RPC_SERVER_ID}
	>
		<ColorModeScript initialColorMode={customTheme.config.initialColorMode} />
		<App />
		<ToastContainer />
	</MoralisProvider>
);
